import { postData } from "@/__main__/get-data.mjs";
import { removeBlitzUser } from "@/feature-auth/fetches/api.mjs";
import UpdateUserResponseModel from "@/feature-auth/models/update-user-response-model.mjs";
import getBearerToken from "@/feature-auth/utils/get-auth-request-header.mjs";
import { devError } from "@/util/dev.mjs";

export async function removeBlitzUserAccount() {
  let bearerToken, error;

  try {
    bearerToken = await getBearerToken();

    if (!bearerToken) {
      devError("FAILED TO REMOVE BLITZ USER - no bearer token!", error);
      return;
    }

    await postData(removeBlitzUser(), UpdateUserResponseModel, undefined, {
      headers: { Authorization: bearerToken },
    });
  } catch (e) {
    devError("FAILED TO REMOVE BLITZ USER", e);
  }
}
